import { render, staticRenderFns } from "./LiquidationInconsistencies.vue?vue&type=template&id=bb666a12&scoped=true&lang=pug"
import script from "./LiquidationInconsistencies.vue?vue&type=script&lang=js"
export * from "./LiquidationInconsistencies.vue?vue&type=script&lang=js"
import style0 from "./LiquidationInconsistencies.vue?vue&type=style&index=0&id=bb666a12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb666a12",
  null
  
)

export default component.exports